$(document).ready(function ($) {
  let pageOffset = 400;
  if (header_offset_scroll) {
    pageOffset = header_offset_scroll;
  }

  $(".js-nav-trigger").on("click", function (event) {
    event.preventDefault();

    const isMenuOpened = $("body").is(".has-menu-opened");

    if (isMenuOpened) {
      $("body").removeClass("has-menu-opened is-fixed");

      if ($(window).scrollTop() >= pageOffset) {
        $(".header-wrapper").css(
          "transform",
          `translateY(-${$(".header-ad").outerHeight()}px)`
        );
      }
      return;
    } else {
      $(".header-wrapper")
        .css("transform", "translateY(0)")
        .css("transition", "none");
    }

    $("body").toggleClass("has-menu-opened");
  });

  $(".nav .menu-item-has-children > a span").on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();

    $(this)
      .parent()
      .next()
      .slideToggle()
      .parent()
      .toggleClass("is-expanded")
      .siblings()
      .removeClass("is-expanded")
      .find(".nav__dd")
      .slideUp()
      .find(".is-expanded")
      .removeClass("is-expanded");
  });
});
